import { useIntl } from "react-intl";

const CustomDomains = () => {
    const intl = useIntl();
    const messages = {
        header: intl.formatMessage({
            id: "JiraServiceManagementPricingPage.features.CustomDomains.header",
            defaultMessage: "Custom domains (Beta)"
        }),
        body: intl.formatMessage({
            id: "JiraServiceManagementPricingPage.features.CustomDomains.body",
            defaultMessage: "Use a company-branded URL for JSM Help Centers."
        })
    };
    return (
        <>
            <h2>{messages.header}</h2>
            <p>{messages.body}</p>
        </>
    );
};

export default CustomDomains;
